<mat-form-field class="w-100"
  appearance="outline">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }

  @if (multiple()) {
    <mat-chip-grid #chipGrid
      [attr.aria-label]="label()">
      @for (option of selectedOptions; track option.value) {
        <mat-chip-row (removed)="onRemoveChip(option)"
          [attr.aria-label]="option.label">
          {{ option.label }}
          <button matChipRemove
            [attr.aria-label]="'Rimuovi ' + option.label">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input #inputRef
        [placeholder]="placeholder()"
        [formControl]="inputControl"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [required]="required()"
        (blur)="onBlur()" />
    </mat-chip-grid>
  } @else {
    <div class="d-flex align-items-center">
      <input matInput
        #inputRef
        [placeholder]="placeholder()"
        [formControl]="inputControl"
        [matAutocomplete]="auto"
        [required]="required()"
        (blur)="onBlur()" />
      @if (selectedOption && !isDisabled) {
        <button matSuffix
          mat-icon-button
          [attr.aria-label]="'Cancella selezione'"
          (click)="onClearSingle()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }

  <mat-autocomplete #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)">
    @for (option of filteredOptions$ | async; track option.value) {
      <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-autocomplete>

  @if (hint()) {
    <mat-hint>{{ hint() }}</mat-hint>
  }
</mat-form-field>